import React from 'react';
import { Button } from '@mui/material';
import { useSelector } from 'react-redux';
import { selectResults } from '../../store/features/genieSlice';
import FileDownloadIcon from '@mui/icons-material/FileDownload';

const GenieExportButton: React.FC = () => {
  const results = useSelector(selectResults);

  const handleExport = () => {
    if (!results || results.length === 0) return;

    // Format the conversation as text
    const conversationText = results.map((result, index) => {
      let answerText = '';

      if (result.type === 'content') {
        if (result.status === 'COMPLETED') {
          answerText = result.text.content;
        } else if (result.status === 'FAILED') {
          answerText = `Error: ${result.error.error}`;
        }
      } else if (result.type === 'response' && result.statement_response) {
        const tableData = result.statement_response.result?.data_array || [];
        const columns = result.statement_response.manifest?.schema?.columns || [];
        
        // Format table data as text
        if (tableData.length > 0) {
          const header = columns.map((col: any) => col.name).join('\t');
          
          // Helper function to format numeric values with commas
          const formatValue = (value: any) => {
            if (value === null || value === undefined) return '';
            const stringValue = String(value).trim();
            const numValue = Number(stringValue);
            
            if (!isNaN(numValue) && isFinite(numValue)) {
              return Number.isInteger(numValue) 
                ? numValue.toLocaleString() 
                : numValue.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            }
            return stringValue;
          };
          
          const rows = tableData.map((row: any) => row.map(formatValue).join('\t')).join('\n');
          answerText = `${header}\n${rows}`;
        }
      }

      return `Question ${index + 1}:\n${result.question}\n\nAnswer:\n${answerText}\n\n${'-'.repeat(80)}\n`;
    }).join('\n');

    // Create and download the file
    const blob = new Blob([conversationText], { type: 'text/plain' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `genie-conversation-${new Date().toISOString().split('T')[0]}.txt`;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
  };

  return (
    <Button
      variant="outlined"
      onClick={handleExport}
      startIcon={<FileDownloadIcon />}
      disabled={!results || results.length === 0}
      sx={{ mr: 2 }}
    >
      Export Conversation
    </Button>
  );
};

export default GenieExportButton; 